import Vue from "vue";
import Component from "vue-class-component";

@Component
export class UtilsMix extends Vue {
    async backToRoute(mode:number): Promise<void> {
        let routeName='';
        if (mode===0) {
            routeName = this.$routeRules.VisitsNewDetail
        }
        if (mode===1) {
            routeName = this.$routeRules.VisitsNewStatus
        }

        await this.$router.push({
            name: routeName,
            params: { id: this.$router.currentRoute.params["id"] },
        });
    }

}